import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { adminLogin } from "../lib/api";
import { useAdmin } from "../lib/admin";
import { toast } from "sonner";
import { ArrowLeft, Lock } from "lucide-react";
import AdminStatsWidget from "../components/AdminStatsWidget";

const AdminLogin = () => {
  const [pwd, setPwd] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, isAdmin, logout } = useAdmin();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!pwd) return;
    setLoading(true);
    try {
      await adminLogin(pwd);
      login(pwd);
      toast.success("Welcome back, Kay.");
    } catch (err) {
      toast.error("Wrong password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-5 py-10">
      <a
        href="/"
        className="absolute top-6 left-6 inline-flex items-center gap-2 text-sm text-foreground/80 hover:text-[hsl(var(--primary))]"
      >
        <ArrowLeft className="w-4 h-4" /> Back to shop
      </a>

      <div className={`w-full ${isAdmin ? "max-w-2xl" : "max-w-md"} bg-[hsl(var(--background))] border border-border/70 rounded-sm p-8`}>
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-sm border border-[hsl(var(--primary))]/40 flex items-center justify-center text-[hsl(var(--primary))]">
            <Lock className="w-5 h-5" />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#B8935F] font-medium">
              Owner area
            </div>
            <h1 className="font-serif text-2xl text-foreground leading-none mt-1">
              Sign in to edit
            </h1>
          </div>
        </div>

        {isAdmin ? (
          <div className="space-y-6">
            <p className="text-sm text-muted-foreground">
              Welcome back, Kay. Here&apos;s a peek at your store this week.
            </p>

            <AdminStatsWidget />

            <div className="flex gap-2 pt-2 border-t border-border/60">
              <Button asChild className="rounded-sm flex-1 bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90">
                <a href="/">Go to shop</a>
              </Button>
              <Button
                variant="outline"
                onClick={() => {
                  logout();
                  toast.success("Signed out");
                }}
                className="rounded-sm"
              >
                Sign out
              </Button>
            </div>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <Input
              data-testid="admin-password-input"
              type="password"
              autoFocus
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              placeholder="Admin password"
              className="h-11 rounded-sm"
            />
            <Button
              data-testid="admin-login-btn"
              type="submit"
              disabled={loading}
              className="w-full h-11 rounded-sm bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90 text-[hsl(var(--primary-foreground))]"
            >
              {loading ? "Signing in…" : "Sign in"}
            </Button>
            <p className="text-[11px] text-muted-foreground text-center">
              Default password is <span className="font-mono">kays2026</span>. Ask the
              agent to change it anytime.
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default AdminLogin;
